import { render } from "./SupervisedEntitiesItem.vue?vue&type=template&id=9758cb24"
import script from "./SupervisedEntitiesItem.vue?vue&type=script&lang=js"
export * from "./SupervisedEntitiesItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\FinanssivalvontaCMS12\\Finanssivalvonta.web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__